import { type ReactNode } from "react";

import styled from "@emotion/styled";
import {
  Pathfinder,
  openApiResolver,
  storage,
} from "@kode-frontend/pathfinder-web";

import { getClientEnv } from "@shared/libs/runtime-env";

// import clientGatewaySpec from "@kex/api/reference/client-gateway-openapi.yaml";

const Wrapper = styled.div`
  .bAVaLm {
    height: 90vh;
  }
  table {
    tr {
      display: flex;
      flex-flow: column;
    }
  }
`;

type Props = {
  children: ReactNode;
};

export const PathfinderProvider = ({ children }: Props) => {
  const isEnabled = getClientEnv("DEV", false);

  if (isEnabled) {
    return <>{children}</>;
  }

  return (
    <>
      <Wrapper>
        <Pathfinder
          active
          dataKey="kex-web-pathfinder-data"
          defaultSpecs={[]}
          resolver={openApiResolver}
          storage={storage}
        >
          {children}
        </Pathfinder>
      </Wrapper>
    </>
  );
};
